import { BadgeData } from './types';
import { StyledCornerBadge } from './style';
import { EBadgeType } from 'utils/enums';

function Badge(badgeData: BadgeData) {
  const emblemPic =
    badgeData.emblem?.imageUrl || badgeData.badge?.emblem?.imageUrl;
  const ribbonText = badgeData.ribbon?.text || badgeData.badge?.ribbon?.text;
  const background = emblemPic && `url(${emblemPic})`;

  return (
    <StyledCornerBadge
      className={badgeData.className}
      background={
        badgeData.type === EBadgeType.SALE
          ? 'url(https://media.appcharge.com/defaults/sale-ribbon-huge.png)'
          : background
      }
      textColor={
        badgeData.ribbon?.textColor || badgeData.badge?.ribbon?.textColor
      }
      position={badgeData.position || badgeData.badge?.position}
    >
      {ribbonText && <p>{ribbonText?.substring(0, 5)}</p>}
    </StyledCornerBadge>
  );
}

export default Badge;
